import styles from "./nossa-empresa-section.module.css";

const NossaEmpresa = () => {
  return (
    <section className={styles.sobre_section}>
      <div className={styles.sobre_div}>
        <div className={styles.title_div}>
          <h1 className={styles.sobre_title}>A EMPRESA</h1>
          <span className={styles.line}></span>
        </div>
        <p className={styles.sobre_text}>
          A TruEvidence nasceu com o objetivo de dar suporte principalmente à
          <b> indústria farmacêutica</b> e instituições de saúde a criar e fazer
          uso das evidências científicas, particularmente{" "}
          <b>
            <i>Real-World Evidence</i> (RWE)
          </b>{" "}
          para implementação e monitoramento de{" "}
          <b>novas tecnologias ou soluções estratégias</b> para sua empresa.
        </p>
        <p className={styles.sobre_text}>
          Utilizamos uma <b>comunicação científica clara e acessível</b>, para
          tornar os resultad eis para todos, sempre prezando pela credibilidade
          das informações levantadas.
        </p>
        <p className={styles.sobre_text}>
          Apesar de ser uma empresa jovem, contamos com um time de consultoria
          com <b>mais de 15 anos de experiência</b> e dedicação a projetos
          relacionados a implementações de tecnologias e melhorias dos sistemas
          de saúde do Brasil.
        </p>
      </div>
    </section>
  );
};

export default NossaEmpresa;
